import { API } from '../utils/constants'

const services = {
  list: API + '/companies',
  delete: API + '/companies',
  detail: API + '/companies',
  register: API + '/companies',
}

export async function getAllCompanies(params?: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(
    params
      ? `${services.list}?start_date=${params.start ?? ''}&end_date=${params.end ?? ''}&status=${params.status ?? ''}`
      : services.list,
    requestOptions,
  ).then((response) => {
    res = response.json()
  })

  return res
}

export async function newCompany(body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(services.register, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteCompany(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.delete}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getCompanyById(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.detail}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getContactsForCompanyById(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.detail}/${id}/contacts`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getQuotationsForCompanyById(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.detail}/${id}/quotations`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateCompanyById(id: any, body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.detail}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
